<div class="client-body">
  <!--<div class="client-sidebar-container">
    <app-client-left-panel></app-client-left-panel>
  </div>-->
  <div class="header-body-container">
    <app-client-header-panel></app-client-header-panel>
    <div style="height:89%">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
